import SvgIcon from './SvgIcon.vue';

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/components/svgIcon/index.js